export interface TechnologyPillar {
  icon: string;
  title: string;
  description: string;
  points: string[];
}

export const technologyPillars: TechnologyPillar[] = [
  {
    icon: '📍',
    title: 'Seat-aware routing engine',
    description:
      'Every order carries section, row, and seat metadata from checkout through delivery, powering accurate runner routing and venue-level fulfillment analytics.',
    points: [
      'Seat data validated at checkout',
      'Routing logic factors walk distance',
      'Section-level fulfillment reporting',
    ],
  },
  {
    icon: '⚡',
    title: 'Real-time order pipeline',
    description:
      'A live order pipeline connects fan checkout to vendor queues to runner dispatch — with status updates flowing in both directions throughout the event.',
    points: [
      'WebSocket-driven live queue updates',
      'Status changes propagate to fans instantly',
      'Vendor and runner views stay synchronized',
    ],
  },
  {
    icon: '💳',
    title: 'Stripe payment integration',
    description:
      'Fans pay securely in the ordering flow via Stripe. Venue settlement and reporting are configured per contract so finance teams stay in control.',
    points: [
      'PCI-compliant payment processing',
      'Per-venue settlement configuration',
      'Transaction reporting in admin dashboard',
    ],
  },
  {
    icon: '🔐',
    title: 'Secure One-Time Verification',
    description:
      'Fans enter their phone number and receive a one-time verification code. No passwords. No app download. Just fast, secure ordering.',
    points: [
      'One-time code verification',
      'No passwords to forget or reset',
      'Verified identity protects order history',
    ],
  },
  {
    icon: '🏟️',
    title: 'Built for game-day scale',
    description:
      'ONI runs on Cloudflare\'s edge infrastructure — designed to handle thousands of concurrent orders across a full stadium without degradation during peak periods.',
    points: [
      'Edge-deployed API and customer app',
      'Handles peak game-day order volume',
      'No single point of failure during events',
    ],
  },
];
